import React from 'react';
import ChatContainer from '../components/Chat/ChatContainer';
import GcPagina from '../components/Layout/GcPagina';
import { FctTarjeta } from '../fct/react';

/**
 * KardioChat: el chat ocupa el alto restante de la ventana (cabecera de contexto y márgenes de la
 * carcasa descontados) y hace scroll dentro de su propia tarjeta, no en la página.
 */
const KardioChatPage: React.FC = () => {
  return (
    <GcPagina seccion="KardioChat" titulo="KardioChat" contexto="Asistente de IA para asesoramiento comercial">
      <FctTarjeta style={{ height: 'calc(100vh - 170px)', minHeight: 360, padding: 0, overflow: 'hidden' }}>
        <ChatContainer />
      </FctTarjeta>
    </GcPagina>
  );
};

export default KardioChatPage;
